// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   MdSearch,
//   MdClear,
//   MdDownload,
//   MdChevronLeft,
//   MdChevronRight,
//   MdFirstPage,
//   MdLastPage,
// } from "react-icons/md";
// import BulkImportButton from "components/common/BulkImportButton";

// import { getOrganizers, deleteOrganizer } from "api/company.api";
// import OrganizerTable from "components/company/OrganizerTable";

// export default function Organizers() {
//   const [data, setData] = useState([]);
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [role, setRole] = useState("admin");
//   const fetchData = async () => {
//     const userData = JSON.parse(localStorage.getItem("userData")) || {};
//     const userRole = userData.role || "admin";
//     setRole(userRole);

//     let parentId = "";

//     // Send parentId/masterCompanyId if user role is 'masterCompany' or 'company'
//     if (userRole === "masterCompany" || userRole === "company") {
//       parentId = userData.masterCompanyId || userData.parentId || "";
//     }

//     // Call API with optional parentId (admin passes "")
//     const res = await getOrganizers(parentId,userRole);
//     console.log("Fetched organizers:", res);
//     setData(res.data || res.data || []);
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const filteredData = data.filter(
//     (item) =>
//       item.companyName?.toLowerCase().includes(search.toLowerCase()) ||
//       item.companyEmail?.toLowerCase().includes(search.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredData.length / limit);

//   const paginatedData = filteredData.slice((page - 1) * limit, page * limit);

//   const exportCSV = () => {
//     const headers = [
//       "Organizer Name",
//       "Organizer Email",
//       "Admin Email",
//       "Status",
//     ];
//     const rows = filteredData.map((c) => [
//       c.companyName,
//       c.companyEmail,
//       c.adminEmail,
//       c.status,
//     ]);

//     let csvContent =
//       "data:text/csv;charset=utf-8," +
//       [headers, ...rows].map((e) => e.join(",")).join("\n");

//     const link = document.createElement("a");
//     link.href = encodeURI(csvContent);
//     link.download = "companies.csv";
//     link.click();
//   };

//   return (
//     <div className="p-4">
//       {role !== "company" &&
//       <div className="mb-4 flex items-center justify-between">
//         <div className="flex items-center gap-2">
//           <div className="relative">
//             <MdSearch className="absolute left-3 top-2.5 text-lg text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search..."
//               value={search}
//               onChange={(e) => {
//                 setSearch(e.target.value);
//                 setPage(1);
//               }}
//               className="w-64 rounded-md border py-2 pl-10 pr-8 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
//             />

//             {search && (
//               <button
//                 onClick={() => setSearch("")}
//                 className="absolute right-2 top-2.5 text-gray-400 hover:text-gray-600"
//               >
//                 <MdClear />
//               </button>
//             )}
//           </div>

//           <button
//             onClick={exportCSV}
//             className="flex items-center gap-1 rounded-lg bg-green-500 px-2 py-1 text-white"
//           >
//             <MdDownload />
//             CSV
//           </button>
//         </div>

//         <div className="flex items-center gap-2">
//           {/* <BulkImportButton module="companies" label="Import Organizer" onSuccess={fetchData} /> */}
//           <Link to="/admin/companies/create" className="btn-primary">
//             Add Organizer
//           </Link>
//         </div>
//       </div>}

//       <div className="rounded-md border bg-white shadow-sm">
//         <OrganizerTable
//           data={paginatedData}
//           onRefresh={fetchData}
//           onDelete={deleteOrganizer}
//         />

//         <div className="flex items-center justify-between border-t px-4 py-3 text-sm">
//           <span className="text-gray-500">{filteredData.length} total</span>

//           <div className="flex items-center gap-1">
//             <select
//               value={limit}
//               onChange={(e) => {
//                 setLimit(Number(e.target.value));
//                 setPage(1);
//               }}
//               className="rounded-md border px-2 py-2 text-sm"
//             >
//               <option value={10}>10 / page</option>
//               <option value={25}>25 / page</option>
//               <option value={50}>50 / page</option>
//             </select>

//             <button
//               disabled={page === 1}
//               onClick={() => setPage(1)}
//               className="rounded border p-2 hover:bg-gray-100 disabled:opacity-40"
//             >
//               <MdFirstPage />
//             </button>

//             <button
//               disabled={page === 1}
//               onClick={() => setPage(page - 1)}
//               className="rounded border p-2 hover:bg-gray-100 disabled:opacity-40"
//             >
//               <MdChevronLeft />
//             </button>

//             <span className="px-3 font-medium">
//               {page} / {totalPages || 1}
//             </span>

//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(page + 1)}
//               className="rounded border p-2 hover:bg-gray-100 disabled:opacity-40"
//             >
//               <MdChevronRight />
//             </button>

//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(totalPages)}
//               className="rounded border p-2 hover:bg-gray-100 disabled:opacity-40"
//             >
//               <MdLastPage />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import { useEffect, useState, useCallback, useRef } from "react";
import { MdSearch, MdDownload, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import { getAllOrganizers, deleteOrganizer } from "api/company.api";
import OrganizerTable from "components/company/OrganizerTable";
import { InputField } from "components/FormFields";
import CustomButton from "components/CustomButton";
import SideDrawerModal from "components/SideDrawerModal";
import ViewCompanyDetails from "components/company/ViewCompanyDetails";

export default function Organizers() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("admin");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedMasterCompany, setSelectedMasterCompany] = useState(
    localStorage.getItem("master_company_id") || ""
  );

  const[isViewOpen,setIsViewOpen] = useState(false)
  const[selectedCompany,setSelectedCompany] = useState(null)
  const [paginationInfo, setPaginationInfo] = useState({
    totalCompanies: 0,
    totalPages: 1,
  });

  const abortControllerRef = useRef(null);

  // 1. Debounce Search Input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  // 2. Fetch Companies with Server-Side Search and Pagination
  const fetchData = useCallback(async () => {
    const userData = JSON.parse(localStorage.getItem("userData")) || {};
    const userRole = userData.role || "admin";
    setRole(userRole);

    // FIXED: Always prefer the dynamically selected master company ID over fixed userData
    const parentId = userData.role === "masterCompany"?selectedMasterCompany||userData.selectedMasterCompany:userData.parentId||"";
      // selectedMasterCompany ||
      // userData.selectedMasterCompany ||
      // userData.parentId ||
      // "";

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      setLoading(true);
      const res = await getAllOrganizers(
        parentId,
        userRole,
        {
          page,
          limit,
          search: debouncedSearch,
        },
        { signal: controller.signal }
      );

      const payload = res.data?.data || res.data || {};
      const companyList =
        payload.companies || (Array.isArray(payload) ? payload : []);

      setData(companyList);
      setPaginationInfo({
        totalCompanies:
          payload.pagination?.totalCompanies || companyList.length,
        totalPages: payload.pagination?.totalPages || 1,
      });
    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") return;
      console.error("Failed to fetch companies:", error);
    } finally {
      setLoading(false);
    }
  }, [page, limit, debouncedSearch, selectedMasterCompany]);

  // Handle Dynamic Event Dispatch for Master Company Changes
  useEffect(() => {
    const handleMasterCompanyChange = (e) => {
      setSelectedMasterCompany(e.detail);
      setPage(1);
    };

    window.addEventListener("masterCompanyChanged", handleMasterCompanyChange);
    return () =>
      window.removeEventListener(
        "masterCompanyChanged",
        handleMasterCompanyChange
      );
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // 3. Row Selection Handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(data.map((item, idx) => item._id || idx));
    } else {
      setSelectedRows([]);
    }
  };

  const handleViewButton = (data) =>{
    setSelectedCompany(data)
    setIsViewOpen(true)
  }
  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // 4. Smart CSV Export
  const handleExportCSV = () => {
    const exportData =
      selectedRows.length > 0
        ? data.filter((item, idx) => selectedRows.includes(item._id || idx))
        : data;

    if (!exportData.length) return;

    const headers = [
      "Company Name",
      "Email",
      "Phone",
      "Location",
      "Tickets Sold",
    ];

    const safeStr = (val) => String(val || "").replace(/"/g, '""');

    const rows = exportData.map((c) => {
      const phone =
        c.companyMobileCountryCode || c.companyMobile
          ? `${c.companyMobileCountryCode || ""} ${
              c.companyMobile || ""
            }`.trim()
          : "N/A";

      const addressParts = [c.companyAddress, c.companyDistrict].filter(
        Boolean
      );
      const location =
        addressParts.length > 0 ? addressParts.join(", ") : "N/A";

      const ticketsSold =
        c.ticketsSold !== undefined && c.ticketsSold !== null
          ? c.ticketsSold
          : 0;

      return [
        `"${safeStr(c.companyName)}"`,
        `"${safeStr(c.email || c.companyEmail)}"`,
        `"${safeStr(phone)}"`,
        `"${safeStr(location)}"`,
        `"${ticketsSold}"`,
      ];
    });

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((e) => e.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `organizers_${
        selectedRows.length > 0 ? "selected" : "all"
      }_${Date.now()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <TablePageLayout>
      {/* --- CONTROL FILTER BAR --- */}
      {role !== "company" &&
      <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {/* Column 1: Search Field */}
        <div className="flex flex-col">
          <InputField
            label="SEARCH"
            name="companyName"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search organizers..."
            icon={<MdSearch className="text-lg text-gray-400" />}
          />
        </div>

        {/* Column 2: Empty */}
        <div className="hidden lg:block"></div>

        {/* Column 3: Empty */}
        <div className="hidden lg:block"></div>

        {/* Column 4: Action Buttons */}
        <div className="flex items-center justify-start gap-2 sm:justify-end lg:justify-end">
          <CustomButton
            label={
              selectedRows.length > 0
                ? `Export Selected (${selectedRows.length})`
                : "Export CSV"
            }
            icon={MdDownload}
            iconPos="left"
            variant="outline"
            color="#1A1A1A"
            borderColor="#02a9e0"
            disabled={data.length === 0}
            onClick={handleExportCSV}
          />

          {role !== "company" && (
            <CustomButton
              label="Add Master Event"
              icon={MdAddBox}
              iconPos="right"
              variant="solid"
              color="#02a9e0"
              onClick={() => (window.location.href = "/admin/companies/create")}
            />
          )}
        </div>
      </div>
      }

      {/* --- MAIN TABLE CONTAINER --- */}
      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading organizers...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <OrganizerTable
            data={data}
            onRefresh={fetchData}
            onDelete={deleteOrganizer}
            selectedRows={selectedRows}
            onSelectRow={handleSelectRow}
            onSelectAll={handleSelectAll}
            viewButton = {handleViewButton}
            role={role}
          />

          {/* --- SERVER-SIDE PAGINATION FOOTER --- */}
          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalCompanies}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}
            <SideDrawerModal
        isOpen={isViewOpen}
        onClose={() => setIsViewOpen(false)}
        title={selectedCompany?.companyName || "Master Company Details"}
        width="600px"
      >
        <ViewCompanyDetails data={selectedCompany} />
      </SideDrawerModal>
    </TablePageLayout>
  );
}
